import React, { useState } from "react";
import "../styles/FAQ.css";
import faqLogo from "../assets/van-logo.png";
import AnimatedTitle from "../components/AnimatedTitle";

const faqData = [
  {
    question: "How to book Mahacabs Tempo Traveller in Mayiladuthurai?",
    answer:
      "You can easily book Mahacabs Tempo Traveller in Mayiladuthurai by calling us, WhatsApp, or through our online booking system. We provide instant confirmation, transparent pricing, and 24/7 support for all your travel needs."
  },
  {
    question: "What are the seating options in Mahacabs Tempo Traveller?",
    answer:
      "Mahacabs offers well-maintained 12 seater, 14 seater, 16 seater, and 18 seater luxury Tempo Travellers. These are ideal for family trips, temple tours, corporate travel, school trips, and wedding travel."
  },
  {
    question: "Does Mahacabs provide AC and Non-AC Tempo Traveller?",
    answer:
      "Yes, Mahacabs provides both AC and Non-AC Tempo Travellers in Mayiladuthurai. You can choose based on your budget, comfort level, and trip requirements."
  },
  {
    question: "What facilities are available inside Mahacabs Tempo Traveller?",
    answer:
      "Our Tempo Travellers come with pushback seats, LED TV, music system, high-quality speakers, premium interiors, ample luggage space, mobile charging points, and free WiFi in selected vehicles for a comfortable journey."
  },
  {
    question: "Is Mahacabs Tempo Traveller service available 24/7?",
    answer:
      "Yes, Mahacabs Tempo Traveller rental service is available 24 hours, 7 days a week for airport pickup, railway station pickup, outstation trips, temple tours, wedding travel, and corporate travel across Tamil Nadu and India."
  },
  {
    question: "Does Mahacabs offer affordable Tempo Traveller packages?",
    answer:
      "Yes, Mahacabs offers budget-friendly and luxury Tempo Traveller packages for South India tours, pilgrimage trips, family vacations, corporate outings, and all-India travel with experienced and professional drivers."
  }
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };


  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Maha Cabs - Tempo Traveller in Mayiladuthurai",
    "image": "https://mahacabs.com/logo.png",
    "telephone": "+919486589488",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Mayiladuthurai",
      "addressRegion": "Tamil Nadu",
      "addressCountry": "IN"
    },
    "priceRange": "₹₹",
    "openingHours": "Mo-Su 00:00-23:59",
    "servesCuisine": "Tempo Traveller Rental, Cab Service, Outstation Travel"
  };

  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Tempo Traveller Rental in Mayiladuthurai",
    "provider": {
      "@type": "LocalBusiness",
      "name": "Maha Cabs"
    },
    "areaServed": {
      "@type": "AdministrativeArea",
      "name": "Tamil Nadu"
    },
    "description": "Luxury AC and Non-AC Tempo Traveller rental service in Mayiladuthurai for family trips, temple tours, corporate travel, airport pickup, and outstation travel across India."
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://mahacabs.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Tempo Traveller",
        "item": "https://mahacabs.com/tempo-traveller"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "FAQ",
        "item": "https://mahacabs.com/faq"
      }
    ]
  };

  return (
    <section className="faq-section">

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />

      <div className="faq-container">

        <div className="faq-subtitle">
          <img src={faqLogo} alt="logo" className="faq-logo" />
          <span>OUR FAQS</span>
        </div>

        <AnimatedTitle
          text="FREQUENTLY ASKING ANY QUESTION"
          className="faq-title"
        />

        {faqData.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${
              activeIndex === index ? "active" : ""
            }`}
          >
            <div
              className="faq-question"
              onClick={() => toggleFAQ(index)}
            >
              <span>{faq.question}</span>

              <div
                className={`arrow-icon ${
                  activeIndex === index ? "open" : ""
                }`}
              >
                <span className="left-bar"></span>
                <span className="right-bar"></span>
              </div>

            </div>

            {activeIndex === index && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
